import { useState } from "react";

import {
  Product,
  ProductActionsWrapper,
  ProductImage,
  ProductImageWrap,
} from "../styles/product";

import {
  Typography,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import "../App.css";

import {
  addFavorite,
  removeFavorite,
} from "../features/favoritesSlice";

import ProductVariationPicker from "./ProductVariationPicker";
import ProductName from "./ProductName";
import ProductPrice from "./ProductPrice";
import DealBadge from "./DealBadge";
import ProductButtons from "./ProductButtons";


export default function SingleProductDesktop({
  width,
  product,
  matches,
}) {
  const [showOptions, setShowOptions] = useState(false);

  const [selectedVariations, setSelectedVariations] =
    useState({});

  const dispatch = useDispatch();

  const favorites = useSelector(
    (state) => state.favorites
  );

  const isFavorite = favorites.some(
    (favorite) => favorite.id === product.id
  );


  const handleMouseEnter = () => {
    setShowOptions(true);
  };


  const handleMouseLeave = () => {
    setShowOptions(false);
  };


  const handleAddToFavorites = () => {
    if (isFavorite) {
      dispatch(removeFavorite(product));
    } else {
      dispatch(addFavorite(product));
    }
  };


  /*
   * בדיקת המלאי של המוצר הראשי.
   *
   * המוצר ייחשב כלא במלאי כאשר:
   * 1. המנהל סימן isInStock כ-false.
   * 2. הכמות של המוצר היא 0.
   */
  const isProductOutOfStock =
    product?.isInStock === false ||
    product?.IsInStock === false 


  /*
   * הווריאציה שנבחרה.
   *
   * בדרך כלל תהיה בחירת צבע או בחירת מידה.
   */
  const selectedVariation =
    selectedVariations?.Color ||
    selectedVariations?.Size ||
    null;


  /*
   * בדיקת המלאי של הווריאציה שנבחרה.
   */
  const isSelectedVariationOutOfStock =
    Boolean(selectedVariation) &&
    (
      selectedVariation?.isInStock === false ||
      selectedVariation?.IsInStock === false 
    );


  /*
   * המוצר לא זמין לרכישה כאשר:
   * - המוצר הראשי לא במלאי.
   * - או שהווריאציה שנבחרה לא במלאי.
   */
  const isOutOfStock =
    isProductOutOfStock ||
    isSelectedVariationOutOfStock;


  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";


  const resolveImgSrc = (image) => {
    if (!image) {
      return null;
    }

    if (image instanceof File) {
      return URL.createObjectURL(image);
    }

    const path = String(image).replace(/\\/g, "/");

    if (
      path.startsWith("http") ||
      path.startsWith("//")
    ) {
      return path;
    }

    return `${API_BASE}${path}`;
  };


  const basePrice =
    Number(product?.price) || 0;


  const selectedExtra =
    Number(
      selectedVariations?.Color?.extraPrice ??
      selectedVariations?.Size?.extraPrice ??
      0
    ) || 0;


  const displayPrice =
    selectedExtra > 0
      ? selectedExtra
      : basePrice;


  const selectedImage =
    selectedVariations?.Color?.image ||
    selectedVariations?.Size?.image ||
    product?.image;


  return (
    <>
      <Product
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <DealBadge product={product} />

        <ProductImageWrap>
          <ProductImage
            src={resolveImgSrc(selectedImage)}
            alt={product?.name || "מוצר"}
          />
        </ProductImageWrap>

        <ProductName
          product={product}
          matches={matches}
        />

        <ProductVariationPicker
          productId={product.id}
          onChange={setSelectedVariations}
        />

        <ProductPrice
          price={displayPrice}
          matches={matches}
        />

        {isOutOfStock && (
          <Typography
            variant="h6"
            color="error"
            sx={{
              mt: 1,
              mb: 1,
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            לא במלאי
          </Typography>
        )}

        <ProductActionsWrapper
          data-show={showOptions || matches}
        />

        <ProductButtons
          product={product}
          selectedVariations={selectedVariations}
          isOutOfStock={isOutOfStock}
        />
      </Product>
    </>
  );
}